import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Grid } from '@material-ui/core'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useClashCount } from '../hooks'
import { useClashesPaneStyles } from '../styles'
import { ClashFilterStatus } from '../types'
import { ClashList } from './ClashList'
import { ClashPanelActions } from './ClashPanelActions'

interface ClashesPaneProps {
    treePath?: string | null
    isSidebarVisible?: boolean
}

/**
 * Pane component for displaying and managing Best Practice clashes
 * Includes filter controls and clash list
 *
 * Related PRs: 177160, 177715
 */
export const ClashesPane = ({
    treePath,
    isSidebarVisible,
}: ClashesPaneProps) => {
    const classes = useClashesPaneStyles()
    const { projectId } = useParams<{ projectId: string }>()
    const [filterStatus, setFilterStatus] = useState<ClashFilterStatus>('active')
    const { refetch: refetchCount } = useClashCount({
        projectId,
        treePath,
    })

    const handleClashResolved = () => {
        refetchCount()
    }

    return (
        <Grid
            data-testid="clashPaneBeta"
            className={clsx(
                classes.sidebar,
                isSidebarVisible ? classes.sidebarOpen : classes.sidebarClosed
            )}
        >
            <GridItem className={classes.clashPanelContainer}>
                <ClashPanelActions
                    filterStatus={filterStatus}
                    onFilterChange={setFilterStatus}
                />
                <ClashList
                    projectId={projectId}
                    treePath={treePath}
                    onClashResolved={handleClashResolved}
                    fullWidth
                    className={classes.clashListWrapper}
                    filterStatus={filterStatus}
                />
            </GridItem>
        </Grid>
    )
}
